import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  CircularProgress,
  Tabs,
  Tab,
  Grid,
  Divider
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useEffect, useState } from "react";
import { isEmpty } from "../../../utils/Util";
import { useLocation } from "react-router-dom";
import * as React from "react";
import ManageDealerLocationGroup from "../DealerLocationGroup/ManageDealerLocationGroup";
import AssignLocationGroup from "../DealerLocationGroup/AssignLocationGroup";
import { useFlags } from "launchdarkly-react-client-sdk";
import ManageSurchargesForGroups from "../DealerLocationGroup/ManageSurchargesForGroups";

enum DealerTabs {
  Surcharge = 0,
  LocationGroups = 1,
  AssingLocationGroup = 2
}

const DealerDetails = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const location = useLocation();
  const dealerData = location?.state?.DealerSummary;
  
  const flags = useFlags();
  const allowGroupLocationManagement = flags.allowGroupLocationManagement;

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };

  return (
    <Box style={{ border: "0px solid red" }}>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        style={{ padding: "0px", paddingRight: "0px" }}
      >
        {isEmpty(dealerData) ? (
          <Box>
            Please wait. Processing.....<CircularProgress></CircularProgress>{" "}
          </Box>
        ) : (
          <Box sx={{ width: "100%" }}>
            {/* Dealer Details Section */}
            <Accordion defaultExpanded>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                  backgroundColor: "#f9f9f9",
                  minHeight: "40px !important",
                  "& .MuiAccordionSummary-content": {
                    margin: 0,
                    alignItems: "center"
                  }
                }}
              >
                <Typography fontWeight="bold">Dealer Detail</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid
                  container
                  spacing={1}
                  sx={{
                    "& .MuiTypography-root": { fontSize: "0.875rem" }
                  }}
                >
                  <Grid item xs={3} sm={3}>
                    <Typography fontWeight="bold">Dealer ID</Typography>
                  </Grid>
                  <Grid item xs={3} sm={3}>
                    <Typography>{dealerData?.dealerId}</Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <Divider />
                  </Grid>

                  <Grid item xs={3} sm={3}>
                    <Typography fontWeight="bold">DMS Dealer ID</Typography>
                  </Grid>
                  <Grid item xs={3} sm={3}>
                    <Typography>{dealerData?.dmsDealerId}</Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <Divider />
                  </Grid>

                  <Grid item xs={3} sm={3}>
                    <Typography fontWeight="bold">Dealer Name</Typography>
                  </Grid>
                  <Grid item xs={3} sm={3}>
                    <Typography>{dealerData?.dealerName}</Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <Divider />
                  </Grid>

                  <Grid item xs={3} sm={3}>
                    <Typography fontWeight="bold">Merchant Name</Typography>
                  </Grid>
                  <Grid item xs={3} sm={3}>
                    <Typography sx={{ minWidth: 310 }}>
                      {dealerData?.merchantId}
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <Divider />
                  </Grid>

                  <Grid item xs={3} sm={3}>
                    <Typography fontWeight="bold">Full Address</Typography>
                  </Grid>
                  <Grid item xs={3} sm={3}>
                    <Typography sx={{ minWidth: 310 }}>
                      {dealerData?.address}, {dealerData?.city},{" "}
                      {dealerData?.zipCode}
                      <br />
                      <b>Phone:</b> {dealerData?.phone}
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <Divider />
                  </Grid>

                  <Grid item xs={3} sm={3}>
                    <Typography fontWeight="bold">Country Code</Typography>
                  </Grid>
                  <Grid item xs={3} sm={3}>
                    <Typography>{dealerData?.countryCode}</Typography>
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>

            {/* Tabs Section */}
            <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
              <Tabs value={tabIndex} onChange={handleTabChange}>
                <Tab
                  label="Surcharge"
                  sx={{
                    textTransform: "none",
                    bgcolor:
                      tabIndex === DealerTabs.Surcharge
                        ? "#f9f9f9"
                        : "transparent"
                  }}
                />
                {allowGroupLocationManagement === true && (
                  <Tab
                    label="Location Groups"
                    sx={{
                      textTransform: "none",
                      bgcolor:
                        tabIndex === DealerTabs.LocationGroups
                          ? "#f9f9f9"
                          : "transparent",
                    }}
                  />
                )}

                {allowGroupLocationManagement === true && (
                  <Tab
                    label="Assign Location Group to Dealer"
                    sx={{
                      textTransform: "none",
                      bgcolor:
                        tabIndex === DealerTabs.AssingLocationGroup
                          ? "#f9f9f9"
                          : "transparent",
                    }}
                  />
                )}
              </Tabs>
            </Box>

            <Box sx={{ mt: 2 }}>
              {tabIndex === DealerTabs.Surcharge && (
                <ManageSurchargesForGroups />
              )}

              {tabIndex === DealerTabs.LocationGroups && (
                <ManageDealerLocationGroup />
              )}
              {tabIndex === DealerTabs.AssingLocationGroup && (
                <AssignLocationGroup />
              )}
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};
export default DealerDetails;
